/**
 * Reference data the pipeline's action forms offer. Taken from the prototype's
 * mock workspace; it moves to the backend with the scheduler and sales modules.
 */

export const ASSIGNEES = ['Administrator', 'Anna Müller', 'Linda Meier'] as const

/** Treatment machines bookable at the studio — only the two Basic devices. */
export const MACHINES = ['Basic 1', 'Basic 2'] as const

export interface Offer {
  id: string
  machineName: string
  name: string
  /** Restricted to a customer segment, when set. */
  eligibility?: string
}

export const OFFERS: Offer[] = [
  { id: 'basic-standard', machineName: 'BeautyLab Basic', name: 'Standardbehandlung' },
  { id: 'premium-standard', machineName: 'BeautyLab Premium', name: 'Standardbehandlung' },
  { id: 'myapro-intro', machineName: 'MyaPro', name: 'Kennenlernbehandlung' },
  { id: 'myapro-10', machineName: 'MyaPro', name: '10-er Block' },
  { id: 'myapro-20', machineName: 'MyaPro', name: '20-er Block' },
  { id: 'myapro-30', machineName: 'MyaPro', name: '30-er Block' },
  { id: 'myapro-abo3', machineName: 'MyaPro', name: 'Abo 3 Monate' },
  { id: 'myapro-abo6', machineName: 'MyaPro', name: 'Abo 6 Monate' },
  { id: 'myapro-abo12', machineName: 'MyaPro', name: 'Abo 12 Monate' },
  { id: 'mya7-intro', machineName: 'Mya7', name: 'Kennenlernbehandlung', eligibility: 'M40' },
  { id: 'mya7-10', machineName: 'Mya7', name: '10-er Block' },
  { id: 'mya7-20', machineName: 'Mya7', name: '20-er Block' },
  { id: 'mya7-abo3', machineName: 'Mya7', name: 'Abo 3 Monate' },
  { id: 'mya7-abo6', machineName: 'Mya7', name: 'Abo 6 Monate' },
  { id: 'mya7-abo12', machineName: 'Mya7', name: 'Abo 12 Monate' },
]

export const offerLabel = (offer: Offer) =>
  `${offer.machineName} · ${offer.name}${offer.eligibility ? ` · nur ${offer.eligibility}` : ''}`

export interface PaymentFlow {
  id: string
  label: string
}

export const PAYMENT_FLOWS: PaymentFlow[] = [
  { id: 'pos', label: 'POS (Kartenzahlung)' },
  { id: 'sepa', label: 'SEPA' },
  { id: 'shopify', label: 'Shopify' },
  { id: 'cash', label: 'Barzahlung' },
  { id: 'ablefy-qr', label: 'Ablefy vor Ort (QR)' },
  { id: 'ablefy-online', label: 'Ablefy Online-Link' },
]

export const ACTIVITY_TYPES = [
  'E-Mail',
  'Anruf',
  'Meeting',
  'To-do',
  'Dokument hochladen',
  'Signatur anfragen',
  'Genehmigung erteilen',
] as const

export type ActivityType = (typeof ACTIVITY_TYPES)[number]
